import { render, staticRenderFns } from "./CloseDirectForm.vue?vue&type=template&id=841c20be"
import script from "./CloseDirectForm.vue?vue&type=script&lang=js"
export * from "./CloseDirectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports